export default {
  phone: /^1\d{10}$/
}